<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <h4 class="pt-3">{{ "session_error_title" | translate }}</h4>
        <p class="text-muted">{{ "session_error_body" | translate }}</p>
        <button type="button" class="btn btn-primary mr-2" (click)="retry()">{{ "try_again" | translate }}</button>
        <button type="button" class="btn btn-outline-secondary" [disabled]="signingOut" (click)="signOut()">{{ "logout" | translate }}</button>
      </div>
    </div>
  </div>
</div>
